require("!!/root/anvel/node_modules/script-loader/addScript.js")(require("!!/root/anvel/node_modules/raw-loader/index.js!/root/anvel/node_modules/sweetalert2/dist/sweetalert2.min.js"))


//////////////////
// WEBPACK FOOTER
// /root/anvel/~/script-loader!/root/anvel/~/sweetalert2/dist/sweetalert2.min.js
// module id = ../../../../script-loader/index.js!../../../../sweetalert2/dist/sweetalert2.min.js
// module chunks = 3